module.exports = __webpack_public_path__ + "static/media/rocket.bb611de9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Shop/assets/rocket.svg
// module id = 791
// module chunks = 20